module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cf_stills_tetra_1l_ades_frutas_tropicales.c72b230d.png";